module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/42157e6edddc19588c3c2ff188703799.svg";